"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestBody = exports.setRequestIDIfPresent = exports.ensureRequestID = void 0;
const uuid_1 = require("uuid");
function ensureRequestID(req) {
    const id = req.headers["x-amz-cf-id"];
    if (id && typeof id === "string") {
        return id;
    }
    const newID = (0, uuid_1.v4)();
    req.headers["x-amz-cf-id"] = newID;
    return newID;
}
exports.ensureRequestID = ensureRequestID;
function setRequestIDIfPresent(requestID, res) {
    if (requestID) {
        res.setHeader("x-request-id", requestID);
    }
}
exports.setRequestIDIfPresent = setRequestIDIfPresent;
async function getRequestBody(req) {
    return new Promise((resolve, reject) => {
        let postBody = "";
        req.on("data", (data) => {
            // convert Buffer to string
            postBody += data.toString();
        });
        req.on("end", () => {
            resolve(postBody);
        });
        req.on("error", (err) => {
            reject(err);
        });
    });
}
exports.getRequestBody = getRequestBody;
//# sourceMappingURL=requests.js.map